export const allSymbols = ['BTC', 'ETH', 'DOGE', 'USDC', 'USDT', 'ALGO', 'DASH', 'LTC', 'WAXP', 'BCH'];
